import * as React from "react";
import { SVGProps } from "react";

const UpgradeWaiting: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.292969" width="120" height="120" rx="60" fill="#FCF4E8" />
    <path
      d="M60.0939 84.2933C46.8548 84.2933 36.0938 73.5323 36.0938 60.2931C36.0938 47.054 46.8548 36.293 60.0939 36.293C73.3331 36.293 84.0941 47.054 84.0941 60.2931C84.0941 73.5323 73.3331 84.2933 60.0939 84.2933ZM60.0939 39.6418C48.7078 39.6418 39.4426 48.907 39.4426 60.2931C39.4426 71.6793 48.7078 80.9444 60.0939 80.9444C71.48 80.9444 80.7452 71.6793 80.7452 60.2931C80.7452 48.907 71.48 39.6418 60.0939 39.6418Z"
      fill="#F0B02A"
    />
    <path
      d="M68.3762 69.0665C68.086 69.0665 67.7958 68.9995 67.5279 68.8209L60.6069 64.6906C58.8878 63.6636 57.6152 61.4087 57.6152 59.4217V50.2682C57.6152 49.3528 58.3743 48.5938 59.2897 48.5938C60.205 48.5938 60.9641 49.3528 60.9641 50.2682V59.4217C60.9641 60.2255 61.6339 61.4087 62.326 61.8106L69.2469 65.9408C70.0507 66.4097 70.2963 67.4367 69.8274 68.2404C69.4925 68.7762 68.9344 69.0665 68.3762 69.0665Z"
      fill="#F0B02A"
    />
  </svg>
);

export default UpgradeWaiting;
